import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

IframeEmbed.propTypes = {
  data: PropTypes.object.isRequired,
};

function IframeEmbed(props) {
  const { data } = props;
  return (
    <div
      className="iframe-wrapper"
      dangerouslySetInnerHTML={{ __html: data.url.html }}
    />
  );
}

export default IframeEmbed;
